import { GridColDef, GridValidRowModel } from '@mui/x-data-grid-premium';

export const conditionalGridColDefs = <
  T extends GridValidRowModel = GridValidRowModel,
>(
  condition: boolean,
  column: GridColDef<T>,
): GridColDef<T>[] => {
  return condition ? [column] : [];
};
